"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreDocumentUploadStepCommandToJSON = exports.PreDocumentUploadStepCommandFromJSONTyped = exports.PreDocumentUploadStepCommandFromJSON = void 0;
function PreDocumentUploadStepCommandFromJSON(json) {
    return PreDocumentUploadStepCommandFromJSONTyped(json, false);
}
exports.PreDocumentUploadStepCommandFromJSON = PreDocumentUploadStepCommandFromJSON;
function PreDocumentUploadStepCommandFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'linkingDocExpectedCount': json['linkingDocExpectedCount'],
    };
}
exports.PreDocumentUploadStepCommandFromJSONTyped = PreDocumentUploadStepCommandFromJSONTyped;
function PreDocumentUploadStepCommandToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'linkingDocExpectedCount': value.linkingDocExpectedCount,
    };
}
exports.PreDocumentUploadStepCommandToJSON = PreDocumentUploadStepCommandToJSON;
//# sourceMappingURL=PreDocumentUploadStepCommand.js.map